<div
  id="GoogleMapsComponent"
  class="card esri-widget animation-on-tool-open"
  #googleMapComponentRef
  gisDraggableWidget
  [dragHandle]="dragArea"
  [ngClass]="mode.toString()"
>
  <!--- the card header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-9" translate>
        Google Maps
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
        <i
          *ngIf="mode !== 'sideBySide' && status !== 'selecting'"
          class="material-icons md-18 float-right pr-1"
          (click)="setMode('sideBySide')"
          [title]="'WIDGET.GOOGLE_MAPS.FULL-SCREEN-TOOLTIP' | translate"
        >fit_screen</i
        >
        <i
          *ngIf="mode !== 'streetViewCentered' && status !== 'selecting'"
          class="material-icons md-18 float-right pr-1"
          (click)="setMode('streetViewCentered')"
          [title]="'WIDGET.GOOGLE_MAPS.SMALL-SCREEN-TOOLTIP' | translate"
        >picture_in_picture_alt</i
        >
        <i
          *ngIf="mode === 'streetViewCentered' && status !== 'selecting'"
          class="material-icons md-18 float-right pr-1"
          (click)="selectPanoramaLocation()"
          [title]="'WIDGET.GOOGLE_MAPS.SELECT-LOCATION-TOOLTIP' | translate"
        >edit_location</i
        >
        <i
          *ngIf="mode === 'streetViewCentered' && status !== 'selecting'"
          class="material-icons md-18 float-right pr-1"
          (click)="centerMap()"
          [title]="'WIDGET.GOOGLE_MAPS.CENTER-MAP-TOOLTIP' | translate"
        >location_searching</i
        >
      </div>
    </div>
  </div>
  <!-- the card body -->
  <div class="card-body">
    <google-maps-widget style="height: 100%;" #googleMapsWidget [options]="widgetOptions">
    </google-maps-widget>
  </div>
</div>
